import { CategoryAirPlaySecurityProfileConfiguration } from '@era/settings-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { AppleAirPlaySecurityPreset } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@rocksoft/shared';
import { Category } from '../router/category';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================

export const CategoryAirplaySecurityProfilePresetConfigurationResolverActions = createActionGroup({
  source: 'Category AirplaySecurity Profile Preset Configuration Resolver',
  events: {
    'Category Profile Preset Configuration Requested': props<{ category: Category }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const CategoryAirplaySecurityProfilePresetConfigurationApiActions = createActionGroup({
  source: 'Category AirplaySecurity Profile Preset Configuration API',
  events: {
    'Category Profile Preset Configuration Loaded': props<{
      configuration: CategoryAirPlaySecurityProfileConfiguration;
      category: Category;
    }>(),
    'Category Profile Preset Configuration Loaded Error': props<{ error: ErrorModel }>(),
    'Category Profile Preset Configuration Added': props<{
      configuration: CategoryAirPlaySecurityProfileConfiguration;
      category: Category;
    }>(),
    'Category Profile Preset Configuration Added Error': props<{
      configuration: CategoryAirPlaySecurityProfileConfiguration;
      category: Category;
      error: ErrorModel;
    }>(),
    'Category Profile Preset Configuration Updated': props<{
      configuration: CategoryAirPlaySecurityProfileConfiguration;
      category: Category;
    }>(),
    'Category Profile Preset Configuration Updated Error': props<{
      configuration: CategoryAirPlaySecurityProfileConfiguration;
      category: Category;
      error: ErrorModel;
    }>(),
    'Category Profile Preset Configuration Deleted': props<{
      configuration: CategoryAirPlaySecurityProfileConfiguration;
      category: Category;
    }>(),
    'Category Profile Preset Configuration Deleted Error': props<{
      configuration: CategoryAirPlaySecurityProfileConfiguration;
      category: Category;
      error: ErrorModel;
    }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryAirplaySecurityProfilePresetConfigurationViewActions = createActionGroup({
  source: 'Category AirplaySecurity Profile Preset Configuration View',
  events: {
    'Profile Preset Configuration Selected': props<{
      category: Category;
      preset: AppleAirPlaySecurityPreset;
      restrict: boolean;
    }>(),
    'Profile Preset Configuration Deselected': props<{
      category: Category;
    }>(),
  },
});
